var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.studentListLoading,
          expression: "studentListLoading",
        },
      ],
      staticClass: "student-answer",
    },
    [
      _c(
        "div",
        { staticClass: "ques-type" },
        [
          _c("answer-radio", {
            attrs: {
              list: _vm.list,
              studentType: _vm.studentType,
              "is-show-position-error": _vm.isShowPositionError,
            },
            on: { "click-item": _vm.clickItem },
          }),
          _vm.showChooseSubject
            ? _c(
                "el-select",
                {
                  staticClass: "options",
                  attrs: { size: "mini", clearable: "", placeholder: "请选择" },
                  on: {
                    change: function ($event) {
                      return _vm.handleCurrentChange()
                    },
                  },
                  model: {
                    value: _vm.currOptional,
                    callback: function ($$v) {
                      _vm.currOptional = $$v
                    },
                    expression: "currOptional",
                  },
                },
                _vm._l(_vm.optionals, function (item) {
                  return _c("el-option", {
                    key: "option-" + item.name,
                    staticClass: "option",
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("div", { staticClass: "search-wrapper" }, [
        _c(
          "div",
          [
            !(_vm.isNeedBatch && _vm.isBatch)
              ? [
                  _vm.loginPlatform === "region"
                    ? [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "200px" },
                            attrs: { size: "mini", placeholder: "选择学校" },
                            on: {
                              change: function ($event) {
                                return _vm.handleChangeSchool()
                              },
                            },
                            model: {
                              value: _vm.answerSchoolId,
                              callback: function ($$v) {
                                _vm.answerSchoolId = $$v
                              },
                              expression: "answerSchoolId",
                            },
                          },
                          _vm._l(_vm.schoolList, function (item, index) {
                            return _c("el-option", {
                              key: "school-" + index,
                              attrs: { label: item.schoolName, value: item.id },
                            })
                          }),
                          1
                        ),
                      ]
                    : _vm._e(),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100px" },
                      attrs: {
                        size: "mini",
                        clearable: "",
                        placeholder: "选择班级",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleCurrentChange()
                        },
                      },
                      model: {
                        value: _vm.classId,
                        callback: function ($$v) {
                          _vm.classId = $$v
                        },
                        expression: "classId",
                      },
                    },
                    _vm._l(_vm.classList, function (item) {
                      return _c("el-option", {
                        key: "class-" + item.id,
                        attrs: { label: item.className, value: item.id },
                      })
                    }),
                    1
                  ),
                  _c("el-input", {
                    staticStyle: { width: "186px" },
                    attrs: {
                      size: "mini",
                      clearable: "",
                      placeholder: "搜索(考号/姓名)",
                      "suffix-icon": "el-icon-search",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.handleCurrentChange()
                      },
                    },
                    model: {
                      value: _vm.keyword,
                      callback: function ($$v) {
                        _vm.keyword = $$v
                      },
                      expression: "keyword",
                    },
                  }),
                ]
              : _vm._e(),
            ["POSITION_ERROR"].indexOf(_vm.studentType.id) >= 0
              ? [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100px" },
                      attrs: { size: "mini", placeholder: "选择批次" },
                      on: {
                        change: function ($event) {
                          return _vm.handleCurrentChange()
                        },
                      },
                      model: {
                        value: _vm.batchId,
                        callback: function ($$v) {
                          _vm.batchId = $$v
                        },
                        expression: "batchId",
                      },
                    },
                    _vm._l(_vm.positionErrorList, function (item) {
                      return _c("el-option", {
                        key: "class-" + item.value,
                        attrs: { label: item.name, value: item.value },
                      })
                    }),
                    1
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
        _c(
          "div",
          [
            _vm.backDoor
              ? [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-margin",
                      attrs: { type: "danger", size: "mini" },
                      on: { click: _vm.cancelAllAbsenceMarks },
                    },
                    [_vm._v("取消全部缺考标记")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-margin",
                      attrs: { type: "warning", size: "mini" },
                      on: { click: _vm.downloadAnomalyList },
                    },
                    [_vm._v("导出异常名单")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-margin",
                      attrs: { type: "danger", size: "mini" },
                      on: { click: _vm.reNewStudent },
                    },
                    [_vm._v("重建学生")]
                  ),
                  _vm.isAewIdentify
                    ? [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "danger", size: "mini" },
                            on: { click: _vm.anewIdentify },
                          },
                          [_vm._v("登分框全部重识别")]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            attrs: { size: "mini" },
                            model: {
                              value: _vm.rendering,
                              callback: function ($$v) {
                                _vm.rendering = $$v
                              },
                              expression: "rendering",
                            },
                          },
                          [_vm._v("分数转红色")]
                        ),
                      ]
                    : _vm._e(),
                ]
              : _vm._e(),
            _vm.isNeedBatch
              ? [
                  _c(
                    "el-button",
                    {
                      staticClass: "el-icon-sort",
                      attrs: { type: "text" },
                      on: {
                        click: function ($event) {
                          _vm.isBatch = !_vm.isBatch
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.isBatch ? "单个" : "批量") + "处理")]
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isNeedBatch && _vm.isBatch,
              expression: "isNeedBatch && isBatch",
            },
          ],
        },
        [
          _c("batch-question", {
            ref: "batchQuestion",
            attrs: {
              "student-type": _vm.studentType,
              "exam-id": _vm.examId,
              "school-id": _vm.answerSchoolId,
            },
            on: { "click-item": _vm.clickItem },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !(_vm.isNeedBatch && _vm.isBatch),
              expression: "!(isNeedBatch && isBatch)",
            },
          ],
        },
        [
          _c(
            "div",
            { staticClass: "student-answer-content" },
            [
              _c("answer-student-list", {
                ref: "studentList",
                attrs: {
                  studentList: _vm.studentList,
                  showErrorDesc: _vm.studentType.id === "POSITION_ERROR",
                },
                on: {
                  handleSelectionChange: _vm.handleSelectionChange,
                  handleRowChange: _vm.handleRowChange,
                },
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.imgLoading,
                      expression: "imgLoading",
                    },
                  ],
                  staticClass: "student-img",
                },
                [
                  _c("div", { staticClass: "tab-bar" }, [
                    _c("div", { staticClass: "tab-left" }, [
                      !_vm.isOnline && _vm.isReadWritePermission(2)
                        ? _c(
                            "div",
                            [
                              _c(
                                "span",
                                { staticStyle: { "margin-right": "8px" } },
                                [_vm._v("批改详情")]
                              ),
                              _c("el-switch", {
                                attrs: {
                                  "active-color": "#13ce66",
                                  disabled:
                                    _vm.currStudent.NotAnnotations.length ===
                                      0 || _vm.missExam,
                                },
                                model: {
                                  value: _vm.showCorrectionDetail,
                                  callback: function ($$v) {
                                    _vm.showCorrectionDetail = $$v
                                  },
                                  expression: "showCorrectionDetail",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                    _vm.currStudent.isAnswer
                      ? _c(
                          "div",
                          { staticClass: "tab-right" },
                          [
                            _c("i", { on: { click: _vm.handleRotate } }, [
                              _c("img", {
                                staticStyle: { "margin-left": "6px" },
                                attrs: {
                                  src: require("images/answer/rotate.svg"),
                                },
                              }),
                            ]),
                            _c(
                              "i",
                              {
                                staticStyle: { padding: "8px 8px 8px 0" },
                                on: { click: _vm.handPreview },
                              },
                              [
                                _c("img", {
                                  staticStyle: { "margin-left": "6px" },
                                  attrs: {
                                    src: require("images/answer/browse.svg"),
                                  },
                                }),
                              ]
                            ),
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  "popper-class": "scale-item-popover",
                                  placement: "bottom",
                                  trigger: "hover",
                                },
                                model: {
                                  value: _vm.scaleDownVisible,
                                  callback: function ($$v) {
                                    _vm.scaleDownVisible = $$v
                                  },
                                  expression: "scaleDownVisible",
                                },
                              },
                              [
                                _c(
                                  "ul",
                                  { staticClass: "scale-item-more" },
                                  _vm._l(
                                    _vm.scaleCollection,
                                    function (scale, index) {
                                      return _c(
                                        "li",
                                        {
                                          key: "scale-" + index,
                                          staticClass: "scale-item",
                                          class: {
                                            active:
                                              _vm.currScale.value ===
                                              scale.value,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleChangeScale(
                                                scale
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" " + _vm._s(scale.title))]
                                      )
                                    }
                                  ),
                                  0
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn-margin",
                                    attrs: {
                                      slot: "reference",
                                      type: "text",
                                      size: "small",
                                    },
                                    slot: "reference",
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.currScale.title) + " "
                                    ),
                                    _vm.scaleDownVisible
                                      ? _c("i", {
                                          staticClass: "el-icon-arrow-up",
                                        })
                                      : _c("i", {
                                          staticClass: "el-icon-arrow-down",
                                        }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "student-img-warpper" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.currStudent.isAnswer,
                            expression: "currStudent.isAnswer",
                          },
                        ],
                      },
                      [
                        _c("div", { style: _vm.imageStyle }, [
                          _c("canvas", { ref: "studentImg" }),
                        ]),
                      ]
                    ),
                    !_vm.currStudent.isAnswer
                      ? _c("div", { staticClass: "nodata" }, [
                          _vm._m(0),
                          _vm.isOnline
                            ? _c("p", { staticClass: "nodata-text" }, [
                                _vm._v("在线考试无需上传答题卡"),
                              ])
                            : _c("p", { staticClass: "nodata-text" }, [
                                _vm._v("暂未上传答题卡"),
                              ]),
                        ])
                      : _vm._e(),
                    _vm.currStudent.hasGrading &&
                    _vm.currStudent.studentPaperType === "DOUBT_REPEAT"
                      ? _c("div", { staticClass: "marking-desc" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.currStudent.gradingTeachers
                                  ? _vm.currStudent.gradingTeachers.join("、")
                                  : ""
                              ) +
                              "已批阅 "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.updateStudentLoading,
                      expression: "updateStudentLoading",
                    },
                  ],
                  staticClass: "student-info",
                },
                [
                  _vm.studentList.length > 0
                    ? [
                        _c(
                          "div",
                          { staticClass: "student-detail" },
                          [
                            _c(
                              "div",
                              [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("考号："),
                                ]),
                                _c("student-auto-complete", {
                                  key: "examNo",
                                  attrs: {
                                    input: _vm.studentInfo.examNo,
                                    "exam-info": _vm.examInfo,
                                    placeholder: "请输入考号/学生名称",
                                    disabled:
                                      ["UN_UPLOAD", "POSITION_ERROR"].indexOf(
                                        _vm.currStudent.studentPaperType
                                      ) >= 0,
                                  },
                                  on: {
                                    confirmStudent:
                                      _vm.handleSearchStudentClick,
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("姓名："),
                                ]),
                                _c("student-auto-complete", {
                                  key: "studentName",
                                  attrs: {
                                    input: _vm.studentInfo.studentName,
                                    "exam-info": _vm.examInfo,
                                    placeholder: "请输入考号/学生名称",
                                    disabled:
                                      ["UN_UPLOAD", "POSITION_ERROR"].indexOf(
                                        _vm.currStudent.studentPaperType
                                      ) >= 0,
                                  },
                                  on: {
                                    confirmStudent:
                                      _vm.handleSearchStudentClick,
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("div", [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("参与统计："),
                              ]),
                              _c("span", { staticClass: "exam-result" }, [
                                _vm.currStudent.examResult &&
                                ["UPLOAD"].indexOf(
                                  _vm.currStudent.studentPaperType
                                ) > -1
                                  ? _c(
                                      "span",
                                      [
                                        _c("el-switch", {
                                          attrs: {
                                            disabled: !_vm.isPermission,
                                            "active-value": 1,
                                            "inactive-value": 0,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.handleCountSwitch()
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.currStudent.examResult
                                                .amentiaFlag,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.currStudent.examResult,
                                                "amentiaFlag",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "currStudent.examResult.amentiaFlag",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-size": "13px",
                                          "line-height": "22px",
                                        },
                                        attrs: { title: _vm.amentiaReason },
                                      },
                                      [_vm._v(" " + _vm._s(_vm.amentiaReason))]
                                    ),
                              ]),
                            ]),
                            _vm.isPermission
                              ? [
                                  _c(
                                    "div",
                                    [
                                      ["UPLOAD", "ABSENT", "UN_UPLOAD"].indexOf(
                                        _vm.currStudent.studentPaperType
                                      ) > -1
                                        ? [
                                            _c(
                                              "span",
                                              { staticClass: "label" },
                                              [_vm._v("缺考：")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  cursor: "pointer",
                                                  "margin-right": "16px",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.missExamVisible = true
                                                  },
                                                },
                                              },
                                              [
                                                _c("el-checkbox", {
                                                  staticStyle: {
                                                    "pointer-events": "none",
                                                  },
                                                  model: {
                                                    value: _vm.missExam,
                                                    callback: function ($$v) {
                                                      _vm.missExam = $$v
                                                    },
                                                    expression: "missExam",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        : _vm._e(),
                                      [
                                        "UPLOAD",
                                        "DOUBT_REPEAT",
                                        "DOUBT_STUDENT_ABSENT",
                                        "NOT_IN_JOIN_LIST",
                                        "NO_NAME_PAPER",
                                      ].indexOf(
                                        _vm.currStudent.studentPaperType
                                      ) > -1
                                        ? [
                                            _c(
                                              "span",
                                              { staticClass: "label" },
                                              [_vm._v("无名卷：")]
                                            ),
                                            _vm.currStudent.studentPaperType ===
                                            "UPLOAD"
                                              ? _c("el-checkbox", {
                                                  attrs: { disabled: "" },
                                                })
                                              : _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      cursor: "pointer",
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.UnnamedVolumeClick,
                                                    },
                                                  },
                                                  [
                                                    _c("el-checkbox", {
                                                      staticStyle: {
                                                        "pointer-events":
                                                          "none",
                                                      },
                                                      model: {
                                                        value: _vm.isNameless,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.isNameless = $$v
                                                        },
                                                        expression:
                                                          "isNameless",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              : _vm._e(),
                            _c("div", [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("得分："),
                              ]),
                              _c("span", { staticClass: "text" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.showReport &&
                                        !_vm.missExam &&
                                        _vm.isReadWritePermission(2)
                                        ? _vm.currStudent.examResult
                                          ? _vm.currStudent.examResult
                                              .totScore || 0
                                          : 0
                                        : "--"
                                    ) +
                                    " "
                                ),
                              ]),
                            ]),
                            _vm.isOnline &&
                            _vm.currStudent &&
                            _vm.currStudent.resultId
                              ? _c("div", [
                                  _c("span", { staticClass: "label" }, [
                                    _vm._v("操作："),
                                  ]),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "text",
                                      staticStyle: {
                                        color: "#2877ff",
                                        cursor: "pointer",
                                      },
                                      on: { click: _vm.reUpload },
                                    },
                                    [_vm._v(" 打回重传 ")]
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          2
                        ),
                        !_vm.missExam
                          ? _c(
                              "div",
                              { staticClass: "question-list" },
                              [
                                _vm.currStudent.examResult &&
                                _vm.objectiveList.length > 0 &&
                                !_vm.notStudentInfo
                                  ? [
                                      _c("div", { staticClass: "title" }, [
                                        _vm._v(
                                          "客观题(" +
                                            _vm._s(
                                              _vm.isReadWritePermission(2)
                                                ? _vm.currStudent.examResult
                                                    .objScore || 0
                                                : "--"
                                            ) +
                                            "分) "
                                        ),
                                      ]),
                                      _c(
                                        "ul",
                                        { staticClass: "objective-question" },
                                        _vm._l(
                                          _vm.objectiveList,
                                          function (objective, index) {
                                            return _c(
                                              "li",
                                              { key: "objective-" + index },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "question-num",
                                                    attrs: {
                                                      title: _vm._f(
                                                        "standardQuestionNumber"
                                                      )(objective),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "standardQuestionNumber"
                                                          )(objective)
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _vm.isReadWritePermission(3)
                                                  ? [
                                                      _c(
                                                        "el-popover",
                                                        {
                                                          ref:
                                                            "objective-" +
                                                            objective.num,
                                                          refInFor: true,
                                                          attrs: {
                                                            placement: "bottom",
                                                            trigger: "click",
                                                            "popper-class":
                                                              "objective-popover",
                                                          },
                                                          on: {
                                                            show: function (
                                                              $event
                                                            ) {
                                                              return _vm.initObjectiveAnswer(
                                                                objective
                                                              )
                                                            },
                                                            hide: function (
                                                              $event
                                                            ) {
                                                              return _vm.changeObjectiveAnswer(
                                                                objective
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("div", [
                                                            _c(
                                                              "ul",
                                                              {
                                                                staticClass:
                                                                  "search-student-list",
                                                              },
                                                              _vm._l(
                                                                objective.optionPositions,
                                                                function (
                                                                  option,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "li",
                                                                    {
                                                                      key:
                                                                        "option-" +
                                                                        index,
                                                                      style:
                                                                        _vm.getSelectOptionStyle(
                                                                          objective,
                                                                          option.value
                                                                        ),
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.changeOption(
                                                                              objective,
                                                                              option.value
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          option.value
                                                                        ) + " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ]),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "question-answer",
                                                              style:
                                                                _vm.getObjectiveAnswerStyle(
                                                                  objective
                                                                ),
                                                              attrs: {
                                                                slot: "reference",
                                                                title:
                                                                  objective.answer,
                                                              },
                                                              slot: "reference",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    objective.answer
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  : [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "question-answer",
                                                          style:
                                                            _vm.getObjectiveAnswerStyle(
                                                              objective
                                                            ),
                                                          attrs: {
                                                            slot: "reference",
                                                            title:
                                                              objective.answer,
                                                          },
                                                          slot: "reference",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                objective.answer
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                              ],
                                              2
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  : _vm._e(),
                                _vm.currStudent.examResult &&
                                _vm.subjectiveList.length > 0
                                  ? [
                                      _c("div", { staticClass: "title" }, [
                                        _vm._v(
                                          "主观题(" +
                                            _vm._s(
                                              _vm.showReport &&
                                                _vm.isReadWritePermission(2)
                                                ? _vm.currStudent.examResult
                                                    .subScore || 0
                                                : "--"
                                            ) +
                                            "分)"
                                        ),
                                      ]),
                                      _c(
                                        "ul",
                                        { staticClass: "subjective-question" },
                                        _vm._l(
                                          _vm.subjectiveList,
                                          function (subjective, index) {
                                            return _c(
                                              "li",
                                              { key: "subjective-" + index },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "question-num",
                                                    attrs: {
                                                      title: _vm._f(
                                                        "standardQuestionNumber"
                                                      )(subjective),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "standardQuestionNumber"
                                                          )(subjective)
                                                        )
                                                    ),
                                                  ]
                                                ),
                                                _vm.showReport &&
                                                _vm.isReadWritePermission(2)
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "question-score",
                                                        style: {
                                                          color:
                                                            subjective.score ==
                                                            0
                                                              ? "#FF4C3B"
                                                              : "",
                                                        },
                                                        attrs: {
                                                          title:
                                                            (subjective.score ||
                                                              0) + "分",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleChangeSubjectiveScoreVisible(
                                                              subjective
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              subjective.score ||
                                                                0
                                                            ) +
                                                            "分"
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            )
                          : _vm._e(),
                      ]
                    : _c("div", { staticClass: "nodata" }, [
                        _vm._v(" 暂无数据 "),
                      ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "footer" },
            [
              _vm.pagination.total > 0
                ? [
                    _c(
                      "div",
                      [
                        _c("span", { staticClass: "desc" }, [
                          _vm._v("已选" + _vm._s(_vm.stuSelectCount) + "条"),
                        ]),
                        _c(
                          "span",
                          {
                            staticClass: "span-btn",
                            class: { disabled: _vm.stuSelectCount === 0 },
                            on: {
                              click: function ($event) {
                                _vm.delAnswerSheetVisible =
                                  _vm.stuSelectCount > 0
                              },
                            },
                          },
                          [_vm._v("删除已选")]
                        ),
                        _vm.exceptions.indexOf(_vm.studentType.id) >= 0
                          ? [
                              _c(
                                "span",
                                {
                                  staticClass: "span-btn",
                                  class: { disabled: _vm.stuSelectCount === 0 },
                                  on: { click: _vm.confirmDoubt },
                                },
                                [_vm._v("确认正常")]
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    "popper-class": "help-tip-popover",
                                    effect: "dark",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("span", { staticClass: "help-icon" }),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "help-tip-content",
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          "若您认为答题卡无偏移，可点击“确认正常”，让答题卡进入后续的流程。"
                                        ),
                                      ]),
                                      _c("p", [
                                        _vm._v(
                                          "注：若答题卡存在严重异常，程序无法识别，即使您手动点击“确认正常”，仍然会留在“定位异常”里，那么您需要创建多模板重识别来解决异常卡。"
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                        ["ALL", "POSITION_ERROR"].indexOf(_vm.studentType.id) >=
                        0
                          ? [
                              _c(
                                "span",
                                {
                                  staticClass: "span-btn",
                                  on: { click: _vm.reOcr },
                                },
                                [_vm._v("重识别")]
                              ),
                              _vm.isHenPermission
                                ? [
                                    _vm.studentType.id === "ALL" && _vm.backDoor
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "span-btn",
                                            on: { click: _vm.setPositionError },
                                          },
                                          [_vm._v("标记为定位异常")]
                                        )
                                      : _vm._e(),
                                    _vm.isCreateTemplatePermission
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "span-btn",
                                              on: {
                                                click: _vm.createMultiTemplate,
                                              },
                                            },
                                            [_vm._v("创建多模板")]
                                          ),
                                          _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                "popper-class":
                                                  "help-tip-popover",
                                                effect: "dark",
                                                content: _vm.templateTip,
                                                placement: "top",
                                              },
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "help-icon",
                                              }),
                                            ]
                                          ),
                                        ]
                                      : _vm._e(),
                                  ]
                                : _vm._e(),
                              _vm.studentType.id === "POSITION_ERROR"
                                ? [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "span-btn",
                                        on: { click: _vm.restorePaperAction },
                                      },
                                      [_vm._v("还原到原卷")]
                                    ),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          "popper-class": "help-tip-popover",
                                          effect: "dark",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "help-icon",
                                        }),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "help-tip-content",
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _c("p", [
                                              _vm._v(
                                                "若使用多模板重识别后，学生答题卡出现拼接异常，可通过还原到原卷功能，恢复到扫描仪第一次扫描、上传的状态。"
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                : _vm._e(),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c("yue-pagination", {
                      key: "single",
                      attrs: { pageSizes: _vm.pageSizes, page: _vm.pagination },
                      on: {
                        "current-change": _vm.handleCurrentChange,
                        "size-change": _vm.handleSizeChange,
                      },
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _vm.isAewIdentify
        ? _c("label", { staticClass: "identify-tip" }, [
            _vm._v("如有半分框，请勿重识别!"),
          ])
        : _vm._e(),
      _c(
        "yue-dialog",
        {
          attrs: {
            visible: _vm.labelUnnamedVolumeVisible,
            title: "无名卷设置",
            width: "500px",
            center: "",
            "custom-class": "label-unnamed-volume",
          },
          on: {
            "update:visible": function ($event) {
              _vm.labelUnnamedVolumeVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "content" }, [
            _vm._v(" 设置无名卷后，该考试将取消学生信息！ "),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { height: "34px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.labelUnnamedVolume },
                },
                [_vm._v(" 确定 ")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { height: "34px" },
                  on: {
                    click: function ($event) {
                      _vm.labelUnnamedVolumeVisible = false
                    },
                  },
                },
                [_vm._v(" 取消 ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "yue-dialog",
        {
          attrs: {
            visible: _vm.delAnswerSheetVisible,
            title: "提示",
            width: "500px",
            center: "",
            "custom-class": "del-answer-sheet",
          },
          on: {
            "update:visible": function ($event) {
              _vm.delAnswerSheetVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "content" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _c(
                  "div",
                  { staticClass: "title" },
                  [
                    _c(
                      "el-radio",
                      {
                        attrs: { label: "1" },
                        model: {
                          value: _vm.delType,
                          callback: function ($$v) {
                            _vm.delType = $$v
                          },
                          expression: "delType",
                        },
                      },
                      [_vm._v("删除所选试卷")]
                    ),
                  ],
                  1
                ),
                _vm.delType === "1"
                  ? [
                      _c("div", { staticClass: "text" }, [
                        _vm._v("确定要删除选中的 "),
                        _c("span", { staticStyle: { color: "#FF4C3B" } }, [
                          _vm._v(_vm._s(_vm.stuSelectCount) + "份"),
                        ]),
                        _vm._v(" 试卷？ "),
                      ]),
                      _c("div", { staticClass: "text" }, [
                        _vm._v("删除后试卷信息会丢失！"),
                      ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _vm.exceptions.indexOf(_vm.studentType.id) === -1
              ? _c(
                  "div",
                  { staticClass: "right" },
                  [
                    _c(
                      "div",
                      { staticClass: "title" },
                      [
                        _c(
                          "el-radio",
                          {
                            attrs: { label: "2" },
                            on: {
                              change: function () {
                                _vm.delStudentNumberType = "2"
                              },
                            },
                            model: {
                              value: _vm.delType,
                              callback: function ($$v) {
                                _vm.delType = $$v
                              },
                              expression: "delType",
                            },
                          },
                          [_vm._v("删除重复学号")]
                        ),
                      ],
                      1
                    ),
                    _vm.delType == "2"
                      ? [
                          _c(
                            "div",
                            { staticClass: "text" },
                            [
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: "1" },
                                  model: {
                                    value: _vm.delStudentNumberType,
                                    callback: function ($$v) {
                                      _vm.delStudentNumberType = $$v
                                    },
                                    expression: "delStudentNumberType",
                                  },
                                },
                                [_vm._v("保存最新数据")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "text" },
                            [
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: "2" },
                                  model: {
                                    value: _vm.delStudentNumberType,
                                    callback: function ($$v) {
                                      _vm.delStudentNumberType = $$v
                                    },
                                    expression: "delStudentNumberType",
                                  },
                                },
                                [_vm._v("保留最早数据")]
                              ),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { height: "34px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.delAnswerSheet },
                },
                [_vm._v(" 确定删除")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { height: "34px" },
                  on: {
                    click: function ($event) {
                      _vm.delAnswerSheetVisible = false
                    },
                  },
                },
                [_vm._v(" 取消 ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "yue-dialog",
        {
          attrs: {
            visible: _vm.missExamVisible,
            title: "缺考设置",
            width: "500",
            center: "",
            "custom-class": "miss-exam",
          },
          on: {
            "update:visible": function ($event) {
              _vm.missExamVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "content" }, [
            _c(
              "div",
              {
                staticStyle: { "margin-top": "20px", "margin-bottom": "32px" },
              },
              [_vm._v(" 设置缺考后，该考生本次考试将没有成绩！ ")]
            ),
            _c(
              "div",
              [
                _c(
                  "el-radio",
                  {
                    attrs: { label: "1" },
                    model: {
                      value: _vm.examState,
                      callback: function ($$v) {
                        _vm.examState = $$v
                      },
                      expression: "examState",
                    },
                  },
                  [
                    _c("span", { staticStyle: { "margin-left": "8px" } }, [
                      _vm._v("缺考"),
                    ]),
                  ]
                ),
                _c(
                  "el-radio",
                  {
                    attrs: { label: "2" },
                    model: {
                      value: _vm.examState,
                      callback: function ($$v) {
                        _vm.examState = $$v
                      },
                      expression: "examState",
                    },
                  },
                  [
                    _c("span", { staticStyle: { "margin-left": "8px" } }, [
                      _vm._v("正常考试"),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { height: "34px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.handleChangeMissExam },
                },
                [_vm._v(" 确定修改")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { height: "34px" },
                  on: {
                    click: function ($event) {
                      _vm.missExamVisible = false
                    },
                  },
                },
                [_vm._v(" 取消 ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "yue-dialog",
        {
          attrs: {
            visible: _vm.setSubjectiveScoreVisible,
            title: "修改分数",
            width: "500",
            center: "",
            "custom-class": "set-subjective-score",
          },
          on: {
            "update:visible": function ($event) {
              _vm.setSubjectiveScoreVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "content" },
            [
              _c(
                "el-form",
                {
                  ref: "setSubjectiveScore",
                  staticStyle: { margin: "0 130px" },
                  attrs: {
                    "label-width": "100px",
                    model: _vm.currSubjective,
                    rules: _vm.rules,
                  },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c("el-form-item", { attrs: { label: "题目编号：" } }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("standardQuestionNumber")(_vm.currSubjective)
                        )
                      ),
                    ]),
                  ]),
                  _c("el-form-item", { attrs: { label: "题目满分：" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.currSubjective.maxScore))]),
                  ]),
                  _c("el-form-item", { attrs: { label: "阅卷详情：" } }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.currSubjective.batchTeacherName)),
                    ]),
                  ]),
                  _c("el-form-item", { attrs: { label: "阅卷分数：" } }, [
                    _vm._v(_vm._s(_vm.currSubjective.score || 0)),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: "修改分数：", prop: "studentScore" } },
                    [
                      _c(
                        "span",
                        { staticStyle: { display: "flex", width: "80px" } },
                        [
                          _c("el-input", {
                            staticStyle: { "margin-right": "8px" },
                            attrs: { type: "number" },
                            model: {
                              value: _vm.currSubjective.studentScore,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.currSubjective,
                                  "studentScore",
                                  _vm._n($$v)
                                )
                              },
                              expression: "currSubjective.studentScore",
                            },
                          }),
                          _vm._v("分 "),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("template", { slot: "footer" }, [
            _c("span", { staticStyle: { color: "red", "font-size": "14px" } }, [
              _vm._v(
                "请修改完全部成绩后，点击考试列表-更多-重新生成单科报告，生成最新报告"
              ),
            ]),
            _c(
              "span",
              { staticClass: "dialog-footer" },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { height: "34px" },
                    attrs: { type: "primary" },
                    on: { click: _vm.handleChangeSubjectiveScore },
                  },
                  [_vm._v(" 确定修改")]
                ),
                _c(
                  "el-button",
                  {
                    staticStyle: { height: "34px" },
                    on: {
                      click: function ($event) {
                        _vm.setSubjectiveScoreVisible = false
                      },
                    },
                  },
                  [_vm._v(" 取消 ")]
                ),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c("el-image", {
        ref: "preview",
        staticClass: "preview-img",
        attrs: {
          src: _vm.previewImage,
          "preview-src-list": [_vm.previewImage],
        },
      }),
      _c("yj-progress", {
        ref: "progressRef",
        attrs: {
          progressDesc: _vm.progressDesc,
          scheduleDialog: _vm.scheduleDialog,
          taskId: _vm.taskId,
        },
        on: { confirm: _vm.closeProgress },
      }),
      _c(
        "yue-dialog",
        {
          attrs: {
            title: "重识别",
            visible: _vm.ocrDialog.visible,
            width: "758px",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.ocrDialog, "visible", $event)
            },
          },
        },
        [
          _c("div", { staticClass: "dialog-body" }, [
            _vm.ocrDialog.templates
              ? _c(
                  "div",
                  { staticClass: "dialog-body-content" },
                  [
                    _c("template-group", {
                      attrs: {
                        form: _vm.ocrDialog,
                        list: _vm.ocrDialog.templates.filter(function (t) {
                          return t.templateNum < 3
                        }),
                      },
                    }),
                    _c("template-group", {
                      attrs: {
                        form: _vm.ocrDialog,
                        list: _vm.ocrDialog.templates.filter(function (t) {
                          return t.templateNum >= 3
                        }),
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "p",
              { staticClass: "dialog-body-footer" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.ocrTemplate },
                  },
                  [_vm._v("确认")]
                ),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "32px" },
                    attrs: { type: "primary", size: "mini", plain: "" },
                    on: {
                      click: function ($event) {
                        _vm.ocrDialog.visible = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "yue-dialog",
        {
          attrs: {
            visible: _vm.restoreScanBatchPaperVisible,
            title: "还原到原卷",
            width: "500px",
            center: "",
            "custom-class": "label-unnamed-volume",
          },
          on: {
            "update:visible": function ($event) {
              _vm.restoreScanBatchPaperVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "content", staticStyle: { "margin-bottom": "0px" } },
            [
              _vm._v(
                " 将还原答题卡到客户端上传后的最初结果，无法撤回，是否确认还原？ "
              ),
            ]
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              staticStyle: { "margin-top": "20px" },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { height: "34px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.restoreScanBatchPaper },
                },
                [_vm._v(" 确定 ")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { height: "34px" },
                  on: {
                    click: function ($event) {
                      _vm.restoreScanBatchPaperVisible = false
                    },
                  },
                },
                [_vm._v(" 取消 ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", { attrs: { src: require("images/unable-preview.png") } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }